import { useState, useEffect, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Scheduler from "./Scheduler";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  carsAdded,
  fieldUpdate,
  updateUnavailableTimeslotDate,
  addCar,
  removeFirstDate,
  updateDates,
} from "../features/counter/counterSlice";
import { db, functions } from "../firebase";
import "react-toastify/dist/ReactToastify.css";
import "../css/index.css";
import { doc, getDoc, collection, addDoc, runTransaction, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import logo_new from "./logo_new.svg";
import { FaPlus } from "react-icons/fa";
import Select from "react-select";
import { BiInfoCircle } from "react-icons/bi";
import moment from "moment";
import Footer from "./Footer/Footer";
import { useDevToolsStatus } from "./useDevToolsStatus.js";
import { v4 as uuidv4 } from "uuid";
import { sendBrevoMail } from "../sendBrevoMail";
import { DEFAULT_RESERVATION_POOLS, DEFAULT_TOTAL_DAILY_CAPACITY, generateDailyTimeSlots, getPoolDailyLimit, getReservationPoolIds, receivingOptionsForPools, reservationMatchesPool } from "../reservationPools";
import { formatPseudo, formatWarehouse, warehouseDateKey, warehouseMonthKey, warehouseNow, warehousePseudoDate, warehouseSlotKey } from "../warehouseTime";

const createSeededRng = (seed) => {
  let s = seed % 2147483647;
  if (s <= 0) s += 2147483646;
  return () => {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
};

const waitMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function PreAlert() {
  const dispatch = useDispatch();
  const isDevToolsOpen = useDevToolsStatus();
  const state = useSelector((state) => state.store);
  const siteName = process.env.REACT_APP_SITE_NAME || "Inbound appointment Slam Hoyerswerda";
  const siteEnv = (process.env.REACT_APP_SITE_ENV || "").toLowerCase();
  const isOschatzSite = siteEnv === "oschatz" || siteName.includes("Oschatz");
  const defaultLooseSlotsPerMonth = isOschatzSite ? 1 : 2;
  const firstDate = useSelector((state) => state.store.firstDate);
  const type = useSelector((state) => state.store.type);
  // console.debug("AKTUALNIE WYBRANY TYP POJAZDU:", type);
  const [emailValidate, setEmailValidate] = useState(true);
  const [isClicked, setIsClicked] = useState(false);
  const [unitsTotal, setUnitsTotal] = useState(0);
  const [palletsTotal, setPalletsTotal] = useState(0);
  const [fields, setFields] = useState(0);
  const [preAlerts, setPreAlerts] = useState([]);
  const unavailableTimeslotDate = useSelector(
    (state) => state.store.unavailableTimeslotDate
  );
  const currentDate = new Date();
  
  // Dynamiczna lista w zależności od lokalizacji
  const getReceivingList = () => {
    if (siteName.includes("Oschatz")) {
      return [
        { id: 1, label: "XPO1", value: "XPO1", name: "XPO1" },
        { id: 2, label: "XWR3", value: "XWR3", name: "XWR3" },
        { id: 3, label: "XDR1/XPLC", value: "XDR1/XPLC", name: "XDR1/XPLC" },
        { id: 4, label: "WRO1", value: "WRO1", name: "WRO1" },
        { id: 5, label: "LCJ2", value: "LCJ2", name: "LCJ2" },
        { id: 6, label: "KTW5", value: "KTW5", name: "KTW5" },
      ];
    }
    
    return receivingOptionsForPools(DEFAULT_RESERVATION_POOLS);
  };
  
  const [receivingList, setReceivingList] = useState(getReceivingList());
  const [reservationPools, setReservationPools] = useState(DEFAULT_RESERVATION_POOLS);
  const [totalDailyCapacity, setTotalDailyCapacity] = useState(DEFAULT_TOTAL_DAILY_CAPACITY);
  const receivingSelectStyles = {
    menuList: (base) => ({
      ...base,
      maxHeight: "220px",
      overflowY: "auto",
    }),
  };

  const [dates, setDates] = useState([]);
  const [customHolidays, setCustomHolidays] = useState([]);
  const [normalSlots, setNormalSlots] = useState(
    (isOschatzSite
      ? ["08:00", "09:20", "10:40", "12:00", "13:20", "14:40"]
      : generateDailyTimeSlots(DEFAULT_TOTAL_DAILY_CAPACITY)
    ).map((time) => {
      const [hour, minute] = time.split(':').map(Number);
      return { hour, minute };
    })
  );
  const [looseSlotsPerMonth, setLooseSlotsPerMonth] = useState(defaultLooseSlotsPerMonth);
  const [maxSlotsPerDay, setMaxSlotsPerDay] = useState(12);

  const getSessionUUID = () => {
    // Sprawdzamy, czy UUID jest już zapisane w sessionStorage
    let uuid = sessionStorage.getItem("session_uuid");

    // Jeśli UUID jeszcze nie istnieje, generujemy nowy i zapisujemy go
    if (!uuid) {
      uuid = uuidv4(); // Generowanie UUID
      sessionStorage.setItem("session_uuid", uuid); // Zapisujemy UUID w sessionStorage
    }

    return uuid; // Zwracamy UUID
  };

useEffect(() => {
    // Ustawiamy " słuchacza" na naszej kolekcji alertów
    const alertsCollectionRef = collection(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'alerts');

    const unsubscribe = onSnapshot(alertsCollectionRef, (querySnapshot) => {
        const alertsList = [];
        querySnapshot.forEach((doc) => {
            alertsList.push({ docId: doc.id, ...doc.data() });
        });

        // Exclude cancelled reservations — ghost reservations must not block slots
        const activeAlerts = alertsList.filter(alert => alert.isCancel !== true);
        setPreAlerts(activeAlerts);

        // Logika przetwarzania dat, która była u Ciebie
        const newDates = activeAlerts.map((alert) =>
          formatWarehouse(alert.firstDate, 'yyyy-MM-dd HH:mm:ss')
        );
        setDates(newDates);
    });

    // Zwracamy funkcję, która "odsubskrybuje" nasłuchiwanie, gdy komponent zostanie zamknięty
    return () => unsubscribe();

}, []); 

// NOWY useEffect do pobierania świąt z bazy
useEffect(() => {
  const calendarDocRef = doc(db, 'calendar', 'i5UKDRTsOKiBbTcUWiN6');
  const unsubscribe = onSnapshot(calendarDocRef, (docSnap) => {
    if (docSnap.exists() && docSnap.data().holidays) {
      const datesFromDB = docSnap.data().holidays.map(holidayTimestamp => {
        return formatWarehouse(holidayTimestamp, 'yyyy-MM-dd');
      });
      setCustomHolidays(datesFromDB);
    }
  });
  return () => unsubscribe();
}, []);

// Pobierz ustawienia slotów z bazy
useEffect(() => {
  const loadSlotsConfig = async () => {
    try {
      const slotsConfigRef = doc(db, 'calendar', 'slotsConfig');
      const docSnap = await getDoc(slotsConfigRef);
      if (docSnap.exists()) {
        const config = docSnap.data();
        if (Array.isArray(config.reservationPools) && config.reservationPools.length > 0) {
          setReservationPools(config.reservationPools);
          if (!isOschatzSite) setReceivingList(receivingOptionsForPools(config.reservationPools));
        }
        const configuredTimes = isOschatzSite
          ? config.normalSlots
          : generateDailyTimeSlots(config.totalDailyCapacity ?? DEFAULT_TOTAL_DAILY_CAPACITY);
        if (!isOschatzSite) setTotalDailyCapacity(Number(config.totalDailyCapacity ?? DEFAULT_TOTAL_DAILY_CAPACITY));
        if (Array.isArray(configuredTimes)) {
          const slotsArray = configuredTimes.map(timeStr => {
            const [hour, minute] = timeStr.split(':').map(Number);
            return { hour, minute };
          });
          setNormalSlots(slotsArray);
        }
        if (config.looseSlotsPerMonth !== undefined) setLooseSlotsPerMonth(config.looseSlotsPerMonth);
        if (config.maxSlotsPerDay) setMaxSlotsPerDay(config.maxSlotsPerDay);
      }
    } catch (error) {
      console.error("Error loading slots config:", error);
    }
  };
  loadSlotsConfig();
}, [isOschatzSite]);

  useEffect(() => {
    if (isDevToolsOpen) {
      //window.location.reload();
    }
  }, [isDevToolsOpen]);

  useEffect(() => {
    const totalQuantity = state.cars.reduce(
      (accumulator, car) => parseInt(accumulator) + parseInt(car.quantity),
      0
    );
    setUnitsTotal(totalQuantity);
    const totalPallets = state.cars.reduce(
      (accumulator, car) => parseInt(accumulator) + parseInt(car.palletsNumber),
      0
    );
    setPalletsTotal(totalPallets);
  }, [state]);

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    console.log("handleOpen called, open was:", open, "now setting to:", !open);
    setOpen(!open);
  };

  const onSaveCarsChangedSelect = (id, e) => {
    dispatch(
      carsAdded({
        id: id,
        receiving: e.value,
      })
    );
  };

// NOWA, POPRAWNA WERSJA onSaveCarsChanged
const onSaveCarsChanged = (id, e) => {
  const { name, value } = e.target;
  let valueToSave = value;

  // Walidacja dla trailerów (max 66 palet)
  if (type === 'trailer' && name === 'palletsNumber' && parseInt(value, 10) > 66) {
    toast.error("The maximum number of pallets for a trailer is 66.");
    valueToSave = 66; // Automatycznie popraw na 66
  }

  const payload = {
    id: id,
    [name]: (name === "quantity" || name === "palletsNumber") && valueToSave === "" ? 0 : valueToSave,
  };
  dispatch(carsAdded(payload));
};

// NOWA, POPRAWNA WERSJA FUNKCJI hanleUpdate
const hanleUpdate = (e) => {
  const { name, value } = e.target;

  // Zawsze aktualizuj pole, które zostało zmienione
  dispatch(fieldUpdate({ fieldName: name, value: value }));

  // Jeśli zmieniono właśnie pole 'type'
  if (name === "type") {
    // Zasada dla 'trailer' i 'bus, van': zeruj jednostki (quantity)
    if (value === 'trailer' || value === 'bus, van') {
      state.cars.forEach(car => {
        if (parseInt(car.quantity) !== 0) {
          dispatch(carsAdded({ id: car.id, quantity: 0 }));
        }
      });
    }

    // Zasada dla 'loose': zeruj palety
    if (value === "loose") {
      dispatch(removeFirstDate()); // To już miałeś
      state.cars.forEach(car => {
        if (parseInt(car.palletsNumber) !== 0) {
          dispatch(carsAdded({ id: car.id, palletsNumber: 0 }));
        }
      });
    }

    // Zasada dla 'swapbody': nic nie zerujemy
    if (value === "swapbody") {
      // W tej chwili nie ma żadnych reguł zerowania dla swapbody
    }
  }
};

// NOWA, POPRAWNA WERSJA FUNKCJI handleCheck
const handleCheck = () => {
  // Pobieramy wartości z pierwszego wiersza
  const quantityOfUnits = document.querySelector("#quantity-of-units").value;
  const fbaNumber = document.querySelector("#fba-number").value;
  const noOfPallets = document.querySelector("#no-of-pallets").value;

  // Sprawdzamy pola, które są zawsze wymagane
  if (state.cars[0].receiving === "" || fbaNumber === "") {
    openToast("Please complete all required fields.");
    return;
  }

  // Sprawdzamy pola warunkowe w zależności od typu pojazdu
  switch (type) {
    case 'trailer':
    case 'bus, van':
      if (noOfPallets === "" || parseInt(noOfPallets) === 0) {
        openToast("Please enter the number of pallets.");
        return;
      }
      break;
    case 'loose':
      if (quantityOfUnits === "") {
        openToast("Please enter the quantity of units.");
        return;
      }
      break;
    case 'swapbody':
      if (quantityOfUnits === "" || noOfPallets === "") {
        openToast("Please complete all fields for Swapbody.");
        return;
      }
      break;
    default:
      // Jeśli żaden typ nie jest wybrany
      openToast("Please select a vehicle type.");
      return;
  }

  // Jeśli wszystkie warunki są spełnione, otwieramy kalendarz
  handleOpen();
};

  const openToast = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.error(message, {
        position: "top-center",
      });
    }
  };

  const openToast2 = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.success(message, {
        position: "top-center",
      });
    }
  };

// OSTATECZNA, KOMPLETNA I POPRAWNA WERSJA FUNKCJI sendPreAlert
const sendPreAlert = async () => {
  // --- NOWA BLOKADA - WKLEJ TEN FRAGMENT ---
  if (type === 'trailer') {
const hasTooManyPallets = state.cars.some(car => parseInt(car.palletsNumber, 10) > 66);
    if (hasTooManyPallets) {
      toast.error("The number of pallets for a trailer cannot exceed 66. Please correct the values before sending.");
      return; // Zatrzymaj wysyłanie formularza
    }
  }
    // === SEKCJA WALIDACJI (pozostaje bez zmian) ===
    if (isClicked) return;

    if (
      state.email === "" || state.from === "" || state.type === "" || state.trailerPlates === "" ||
      (state.type === "swapbody" || state.type === "trailer" ? state.swapbodyPlates === "" : "") ||
      state.phoneNumber === "" || state.sealNumber === "" || state.firstDate === ""
    ) {
      openToast("Please complete all required fields");
      return;
    }

    setIsClicked(true);

    let lockAcquired = false;
    const slotLockToken = uuidv4();
    try {
      // 1. Referencje
      const alertsCollectionRef = collection(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'alerts');
      const locksCollectionPath = ['pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'locks'];
      const slotKey = warehouseSlotKey(state.firstDate);

      // 2. Transakcja: próba założenia blokady na slot (globalny lock)
      try {
        for (let attempt = 0; attempt < 3; attempt += 1) {
          try {
            await runTransaction(db, async (transaction) => {
              const lockRef = doc(db, ...locksCollectionPath, slotKey);
              const lockSnap = await transaction.get(lockRef);

              const currentCount = lockSnap.exists() ? (lockSnap.data().count || 0) : 0;
              const capacity = 1;
              if (currentCount >= capacity) {
                throw new Error('Selected time slot is already booked.');
              }

              transaction.set(lockRef, {
                count: currentCount + 1,
                reservationAttemptId: slotLockToken,
                confirmed: false,
                updatedAt: Date.now(),
              }, { merge: true });
            });
            lockAcquired = true;
            break;
          } catch (lockErr) {
            const isResourceExhausted =
              lockErr?.code === 'resource-exhausted' ||
              ("" + lockErr).toLowerCase().includes('quota exceeded');
            if (!isResourceExhausted || attempt === 2) {
              throw lockErr;
            }
            await waitMs(300 * (attempt + 1));
          }
        }
      } catch (txError) {
        const isPermissionError =
          txError?.code === 'permission-denied' ||
          ("" + txError).toLowerCase().includes('insufficient permissions');

        if (!isPermissionError || !isOschatzSite) {
          throw txError;
        }
      }

      // 3. Przygotuj dane do wysłania przez Cloud Function
      const reservationData = {
        from: state.from,
        email: state.email,
        phoneNumber: state.phoneNumber,
        cars: state.cars,
        firstDate: state.firstDate,
        type: state.type,
        trailerType: state.trailerType,
        trailerPlates: state.trailerPlates,
        swapbodyPlates: state.swapbodyPlates,
        swapbodyPlates2: state.swapbodyPlates2,
        sealNumber: state.sealNumber,
        sealNumber2: state.sealNumber2,
        siteName: siteName,
        cancellation_token: uuidv4(),
        slotLockToken,
      };

      // 4. Wywołaj bezpieczną funkcję Cloud Function
      const createSecureReservation = httpsCallable(functions, 'createSecureReservation');
      const result = await createSecureReservation(reservationData);
      
      const newId = result.data.id;
      const newDocRef = { id: result.data.docId };

      // 5. Przygotuj e-mail z pełną treścią i poprawnym ID
      const dateForEmail = formatWarehouse(state.firstDate, 'yyyy-MM-dd HH:mm');
      
      // Dynamiczny link w zależności od lokacji
      const cancelBookingDomain = siteName.includes("Oschatz") 
        ? "https://oschatz.slamwarehouse.com" 
        : "https://hoyerswerda.slamwarehouse.com";

      const emailData = {
        email: state.email,
        id: newId,
        from: siteName.includes("Oschatz") ? "slamfirebaseproject@gmail.com" : "slamhoyerswerda@gmail.com",
        my_html: `<h3>Pre-Alert no #${newId}</h3><br/><br/><p>Dear User,</p><p>We would like to inform you that the pre-alert date has been set for <strong>${dateForEmail}</strong>. If you have any questions, please contact our customer support team.</p><br/>
          <table className="table table-striped">
            <thead>
              <tr>
                <th style='text-align: start;margin: 15px;'>Receiving AMAZON-FC</th>
                <th style='text-align: start;margin: 15px;'>FBA-Number</th>
                <th style='text-align: start;margin: 15px;'>Quantity of units</th>
                <th style='text-align: start;margin: 15px;'>No of pallets</th>
              </tr>
            </thead>
            <tbody>
              ${state.cars.map(car => `
                <tr>
                  <th style='text-align:start;margin: 15px;' scope="row">${car.receiving || ''}</th>
                  <td style='text-align:start;margin: 15px;'>${car.numberFBA || ''}</td>
                  <td style='text-align:start;margin: 15px;'>${car.quantity === 0 ? "" : car.quantity}</td>
                  <td style='text-align:start;margin: 15px;'>${car.palletsNumber === 0 ? "" : car.palletsNumber}</td>
                </tr>
              `).join("")}
            </tbody>
          </table>
          <p>If you want to cancel this booking, please click the link below:</p>
          <a href="${cancelBookingDomain}/cancel-booking/${newDocRef.id}/${reservationData.cancellation_token}">Cancel Booking</a>
          <p>Best regards,<br>Slam Poland</p>`,
      };

      // 6. Wyślij e-mail (nie wpływa na ważność rezerwacji)
      try {
        await sendBrevoMail(emailData);
      } catch (mailErr) {
        console.warn('E-mail sending failed (non-blocking):', mailErr);
        openToast('Pre-alert saved, but failed to send the confirmation e-mail.');
      }

      openToast2("Pre-alert has been sent");
      setTimeout(() => {
        window.location.reload();
      }, 3000);

    } catch (error) {
      console.error("Błąd podczas zapisu pre-alertu lub wysyłania maila: ", error);
      
      // Rollback ewentualnej blokady slotu, jeśli wystąpił błąd po transakcji
      try {
        if (state.firstDate && lockAcquired) {
          const slotKey = warehouseSlotKey(state.firstDate);
          const lockRef = doc(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'locks', slotKey);
          await runTransaction(db, async (tx) => {
            const snap = await tx.get(lockRef);
            if (!snap.exists() || snap.data().reservationAttemptId !== slotLockToken || snap.data().confirmed === true) return;
            tx.delete(lockRef);
          });
        }
      } catch (rbErr) {
        console.warn('Rollback of slot lock failed (non-critical):', rbErr);
      }

      // Handle Cloud Function specific errors
      if (error?.code === 'failed-precondition' || error?.message?.includes('Monthly limit reached')) {
        openToast(error.message || 'Monthly limit for loose reservations reached. Please select a different date or vehicle type.');
      } else if (error && ("" + error).includes('Selected time slot is already booked')) {
        openToast('Selected time slot is already booked. Please pick another.');
      } else if (error?.code === 'resource-exhausted' || (("" + error).toLowerCase().includes('quota exceeded'))) {
        openToast('System is busy. Please try again in a moment.');
      } else if (error?.code === 'permission-denied') {
        openToast('Permission denied. Please try again or contact support.');
      } else {
        openToast(error?.message || `Pre-alert was not sent.`);
      }
      setIsClicked(false);
    }
};

// NOWA, POPRAWNA WERSJA
const checkNumberOfPallets = (date) => {
  if (!preAlerts) {
    return true;
  }
  
  // Filtruj wszystkie pre-alerty na dany dzień (niezależnie od liczby palet)
  const filteredPreAlerts = preAlerts.filter((alert) => {
    if (!alert.firstDate) return false;
    if (alert.isCancel === true) return false; // Safety net: exclude cancelled
    
    // Konwersja daty z alertu
    const alertDate = new Date(
      alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000
    );

    // Sprawdzanie daty (alert w czasie magazynowym, `date` to pseudo-Date slotu)
    const isSameDate = warehouseDateKey(alertDate) === formatPseudo(new Date(date), 'yyyy-MM-dd');

    return isSameDate;
  });

  if (isOschatzSite) return filteredPreAlerts.length < maxSlotsPerDay;

  if (filteredPreAlerts.length >= totalDailyCapacity) return false;

  const selectedPoolIds = getReservationPoolIds(state.cars, reservationPools);
  if (selectedPoolIds.length === 0) return filteredPreAlerts.length < totalDailyCapacity;

  return selectedPoolIds.every((poolId) => {
    const pool = reservationPools.find((candidate) => candidate.id === poolId);
    if (!pool) return true;
    const poolReservations = filteredPreAlerts.filter((alert) => reservationMatchesPool(alert, pool));
    return poolReservations.length < getPoolDailyLimit(pool, date, maxSlotsPerDay);
  });
};

// NOWA WERSJA findAvailableDate (limity loose na miesiąc per lokalizacja)
const findAvailableDate = (startDate) => {
  const isLoose = (type === 'loose');
  
  // Dni robocze: 1=Pon, 2=Wt, 3=Sr, 4=Czw, 5=Pt (zgodnie z moment.js isoWeekday)
  const WEEKDAYS = [1, 2, 3, 4, 5];
  if (!isLoose) {
    let currentDate = moment(warehousePseudoDate(startDate)).add(1, 'hour'); 
    const endSearchDate = moment(warehousePseudoDate(startDate)).add(30, 'days');
    currentDate.hour(8).minute(0);

    while (currentDate.isBefore(endSearchDate)) {
      const dateStr = currentDate.format('YYYY-MM-DD');
      const isWeekday = currentDate.day() !== 0 && currentDate.day() !== 6;
      const isCustomHoliday = customHolidays.includes(dateStr);

      if (isWeekday && !isCustomHoliday) {
        // Sprawdzamy pojemność paletową dla całego dnia
        if (checkNumberOfPallets(currentDate.toDate())) { 
          for (const slot of normalSlots) {
            const slotTime = currentDate.clone().hour(slot.hour).minute(slot.minute).second(0);
            const slotStr = slotTime.format("YYYY-MM-DD HH:mm:ss");
            if (slotTime.isAfter(moment(warehouseNow()).add(24, 'hours')) && !dates.includes(slotStr)) {
              return slotStr; // ZNALEZIONO DLA INNYCH
            }
          }
        }
      }
      currentDate.add(1, 'day').hour(8).minute(0).second(0);
    }
  } 
  // --- NOWA LOGIKA SUGESTII DLA 'loose' (limity na MIESIĄC) ---
  else {
    // Oblicz datę graniczną 24h
    let cutoffTime = moment(warehouseNow()).add(24, 'hours');
    const maxLooseDate = moment(warehouseNow()).add(2, 'months').endOf('day');
    while (
      cutoffTime.day() === 0 || 
      cutoffTime.day() === 6 || 
      (customHolidays && customHolidays.includes(cutoffTime.format('YYYY-MM-DD')))
    ) {
      cutoffTime.add(1, 'day').hour(8).minute(0).second(0);
    }

    const searchStartMonth = cutoffTime.clone().startOf('month');

    // Search monthly loose slots only inside the two-month booking window.
    for (let monthOffset = 0; monthOffset < 12; monthOffset++) {
      const monthDate = searchStartMonth.clone().add(monthOffset, 'month');
      if (monthDate.isAfter(maxLooseDate, 'month')) break;
      
      // CRITICAL: Count existing loose reservations in this month
      // (month boundaries are compared in the warehouse timezone)
      const existingLooseInMonth = preAlerts.filter(alert => {
        if (alert.type !== 'loose' || alert.isCancel) return false;
        return warehouseMonthKey(alert.firstDate) === monthDate.format('YYYY-MM');
      });

      const selectedPools = isOschatzSite
        ? []
        : reservationPools.filter((pool) => getReservationPoolIds(state.cars, [pool]).length > 0);
      const availableLooseSlots = selectedPools.length > 0
        ? Math.min(...selectedPools.map((pool) => {
            const used = existingLooseInMonth.filter((alert) => reservationMatchesPool(alert, pool)).length;
            return Number(pool.looseSlotsPerMonth || 0) - used;
          }))
        : looseSlotsPerMonth - existingLooseInMonth.length;
      
      // Skip this month if limit already reached
      if (availableLooseSlots <= 0) {
        console.log(`[NEXT AVAILABLE] Month ${monthDate.format('YYYY-MM')}: loose capacity reached - SKIPPING`);
        continue;
      }
      
      console.log(`[NEXT AVAILABLE] Month ${monthDate.format('YYYY-MM')}: ${availableLooseSlots} loose slots available`);
      
      const daysInMonth = monthDate.daysInMonth();
      const monthSeed = monthDate.year() * 100 + (monthDate.month() + 1);
      const rngSeed = monthSeed * 100 + (isOschatzSite ? 1 : 2);
      const rng = createSeededRng(rngSeed);
      const candidateSlots = [];

      for (let day = 1; day <= daysInMonth; day++) {
        for (const slot of normalSlots) {
          const slotTime = monthDate.clone()
            .date(day)
            .hour(slot.hour)
            .minute(slot.minute)
            .second(0);

          const slotStr = slotTime.format("YYYY-MM-DD HH:mm:ss");
          const dateStr = slotTime.format('YYYY-MM-DD');
          const isWeekday = WEEKDAYS.includes(slotTime.isoWeekday());
          const isCustomHoliday = customHolidays.includes(dateStr);

          if (
            isWeekday &&
            slotTime.isAfter(cutoffTime) &&
            slotTime.isSameOrBefore(maxLooseDate) &&
            !isCustomHoliday &&
            !dates.includes(slotStr) &&
            checkNumberOfPallets(slotTime.toDate())
          ) {
            candidateSlots.push(slotStr);
          }
        }
      }

      // Deterministyczne tasowanie: ten sam miesiąc => ten sam układ, ale inny miesiąc => inne daty.
      for (let i = candidateSlots.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [candidateSlots[i], candidateSlots[j]] = [candidateSlots[j], candidateSlots[i]];
      }

      // Only take slots that don't exceed the monthly limit
      const monthlySlots = candidateSlots
        .slice(0, availableLooseSlots);

      if (monthlySlots.length > 0) {
        console.log(`[NEXT AVAILABLE] Found available slot: ${monthlySlots[0]}`);
        return monthlySlots[0];
      }
    }
  }

  return "No available dates found.";
};

  const limitedFields = Math.min(fields, 38);

  return (
    <>
      <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
          crossOrigin="anonymous"
        />
        <img
          src={logo_new}
          width="220px"
          style={{ marginTop: "1.5em", marginBottom: "1.5em" }}
          className="rounded mx-auto d-block"
          alt="logo"
        />
        <h2 style={{ textAlign: "center", marginBottom: "1em", marginTop: 0 }}>
        {process.env.REACT_APP_SITE_NAME || "Inbound appointment Slam Hoyerswerda"}
      </h2>
      {isOschatzSite && (
        <p style={{ textAlign: "center", maxWidth: "900px", margin: "0 auto 2rem", padding: "0 1rem" }}>
          <strong style={{ display: "block", marginBottom: "0.5rem", fontSize: "1.1rem" }}>⚙️ INFORMATION ⚙️</strong>
          Please be informed that all deliveries previously scheduled for Oschatz can now be booked for our warehouse in{" "}
          <a href="https://hoyerswerda.slamwarehouse.com" target="_blank" rel="noreferrer">Hoyerswerda</a>.
        </p>
      )}
      <div className="container text-left" style={{ marginBottom: "50px" }}>
        <div className="mb-3">
          <label htmlFor="from" className="form-label">
            From
          </label>
          <input
            type="text"
            className="form-control"
            id="from"
            autoComplete="organization"
            placeholder="Company Name"
            name="from"
            onChange={(e) => {
              hanleUpdate(e);
            }}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="text"
            className="form-control"
            id="email"
            autoComplete="email"
            placeholder="e.g. office@slampoland.pl"
            name="email"
            onChange={(e) => {
              hanleUpdate(e);
            }}
            required
          />
          {!emailValidate ? (
            <p
              style={{
                fontSize: "12px",
                color: "#CC0C39",
                marginLeft: "2px",
                marginTop: "5px",
              }}
            >
              Provide a valid email address
            </p>
          ) : (
            ""
          )}
        </div>
        <div className="mb-3">
          <label htmlFor="phoneNumber" className="form-label">
            Phone number
          </label>
          <input
            type="text"
            className="form-control"
            id="phoneNumber"
            autoComplete="tel"
            placeholder="e.g. +48 777 777 777"
            name="phoneNumber"
            onChange={(e) => {
              hanleUpdate(e);
            }}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="type" className="form-label">
            Type of vehicle
          </label>
          <select
            className="form-control"
            id="type"
            autoComplete="off"
            name="type"
            onChange={(e) => {
              hanleUpdate(e);
            }}
            type="text"
            required
            defaultValue=""
          >
            <option value="" disabled></option>
            <option value="trailer">trailer</option>
            <option value="swapbody">swapbody</option>
            <option value="bus, van">bus, van</option>
            <option value="loose">loose</option>
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="trailerPlates" className="form-label">
            Truck plates
          </label>
          <input
            type="text"
            className="form-control"
            id="trailerPlates"
            autoComplete="off"
            placeholder=""
            name="trailerPlates"
            onChange={(e) => {
              hanleUpdate(e);
            }}
            required
          />
        </div>
        {state.type === "loose" ? (
          <div className="mb-3">
            <label htmlFor="trailerType" className="form-label">
              Trailer type
            </label>
            <select
              className="form-control"
              id="type"
              autoComplete="off"
              name="trailerType"
              onChange={(e) => {
                hanleUpdate(e);
              }}
              type="text"
              required
              defaultValue=""
            >
              <option value="" disabled></option>
              <option>live</option>
              <option>drop</option>
            </select>
          </div>
        ) : (
          ""
        )}
        {state.type === "swapbody" || state.type === "trailer" ? (
          <div className="mb-3">
            <label htmlFor="swapbodyPlates" className="form-label">
              Trailer plate/swapbody #1
            </label>
            <input
              type="text"
              className="form-control"
              id="swapbodyPlates"
              autoComplete="off"
              placeholder=""
              name="swapbodyPlates"
              onChange={(e) => {
                hanleUpdate(e);
              }}
              required
            />
          </div>
        ) : (
          ""
        )}
        {state.type === "swapbody" ? (
          <div className="mb-3">
            <label htmlFor="swapbodyPlates2" className="form-label">
              Swapbody #2
            </label>
            <input
              type="text"
              className="form-control"
              id="swapbodyPlates2"
              autoComplete="off"
              placeholder=""
              name="swapbodyPlates2"
              onChange={(e) => {
                hanleUpdate(e);
              }}
            />
          </div>
        ) : (
          ""
        )}
        <div className="row">
          <div className="col">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Receiving AMAZON-FC</th>
                  <th scope="col">FBA-Number</th>
                  <th scope="col">Quantity of units</th>
                  <th scope="col">No of pallets</th>
                </tr>
              </thead>
              <tbody id="amazon-table">
                <tr>
                  <th scope="row">
                    <Select
                      style={{ paddingTop: "1rem" }}
                      id="receive1"
                      placeholder=""
                      name="receiving"
                      onChange={(e) => {
                        onSaveCarsChangedSelect(1, e);
                      }}
                      options={receivingList}
                      styles={receivingSelectStyles}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      isSearchable={false}
                      required
                    />
                  </th>
                  <td>
                    <input
                      className="form-control"
                      id="fba-number"
                      name="numberFBA"
                      onChange={(e) => {
                        onSaveCarsChanged(1, e);
                      }}
                      type="text"
                      required
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      id="quantity-of-units"
                      disabled={type === 'trailer' || type === 'bus, van'}
                      name="quantity"
                      onChange={(e) => {
                        onSaveCarsChanged(1, e);
                      }}
                      type="number"
                      required
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      id="no-of-pallets"
                      name="palletsNumber"
                      disabled={type === 'loose'}
                      onChange={(e) => {
                        onSaveCarsChanged(1, e);
                      }}
                      type="number"
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <Select
                      style={{ paddingTop: "1rem" }}
                      id="receive2"
                      placeholder=""
                      name="receiving"
                      onChange={(e) => {
                        onSaveCarsChangedSelect(2, e);
                      }}
                      options={receivingList}
                      styles={receivingSelectStyles}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      isSearchable={false}
                      className={
                        state.cars[1].numberFBA !== "" ||
                        state.cars[1].quantity !== 0 ||
                        state.cars[1].palletsNumber !== 0
                          ? state.cars[1].receiving !== ""
                            ? "none"
                            : "error"
                          : "none"
                      }
                    />
                  </th>
                  <td>
                    <input
                      id="fba-number2"
                      name="numberFBA"
                      onChange={(e) => {
                        onSaveCarsChanged(2, e);
                      }}
                      type="text"
                      className={
                        (state.cars[1].receiving !== "" || state.cars[1].quantity !== 0 || state.cars[1].palletsNumber !== 0) && state.cars[1].numberFBA === ""
                          ? "form-control error"
                          : "form-control"
                      }
                    />
                  </td>
                  <td>
                    <input
                      id="quantity-of-units2"
                      name="quantity"
                      onChange={(e) => {
                        onSaveCarsChanged(2, e);
                      }}
                      disabled={type === 'trailer' || type === 'bus, van'}
                      type="number"
                      className={
                        (type === 'trailer' || type === 'bus, van') // Jeśli jest zablokowane
                        ? "form-control" // Użyj domyślnej klasy (bez błędu)
                        : (state.cars[1].receiving !== "" || state.cars[1].numberFBA !== "" || state.cars[1].palletsNumber !== 0) && (state.cars[1].quantity === 0 || state.cars[1].quantity === "")
                        ? "form-control error" // Pokaż błąd tylko, jeśli inne pola są pełne, a to jest puste I odblokowane
                        : "form-control"
                      }
                    />
                  </td>
                  <td>
                    <input
                      id="no-of-pallets2"
                      name="palletsNumber"
                      onChange={(e) => {
                        onSaveCarsChanged(2, e);
                      }}
                      disabled={type === 'loose'}
                      type="number"
                      className={
                        (type === 'loose') // Jeśli jest zablokowane
                        ? "form-control" // Użyj domyślnej klasy (bez błędu)
                        : (state.cars[1].receiving !== "" || state.cars[1].numberFBA !== "" || state.cars[1].quantity !== 0) && (state.cars[1].palletsNumber === 0 || state.cars[1].palletsNumber === "")
                        ? "form-control error" // Pokaż błąd tylko, jeśli inne pola są pełne, a to jest puste I odblokowane
                        : "form-control"
                      }
                    />
                  </td>
                </tr>
                {Array.from({ length: limitedFields }).map((_, index) => (
                  <tr>
                    <th scope="row">
                      <Select
                        style={{ paddingTop: "1.5rem" }}
                        id={`receive${index + 3}`}
                        placeholder=""
                        name="receiving"
                        onChange={(e) => {
                          onSaveCarsChangedSelect(index + 3, e);
                        }}
                        options={receivingList}
                        styles={receivingSelectStyles}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        isSearchable={false}
                        className={
                          (type === 'trailer' || type === 'bus, van') // Jeśli jest zablokowane
                          ? "form-control" // Użyj domyślnej klasy (bez błędu)
                          : (state.cars[index + 2].receiving !== "" || state.cars[index + 2].numberFBA !== "" || state.cars[index + 2].palletsNumber !== 0) && (state.cars[index + 2].quantity === 0 || state.cars[index + 2].quantity === "")
                          ? "form-control error"
                          : "form-control"
                        }
                      />
                    </th>
                    <td>
                      <input
                        id={`fba-number${index + 3}`}
                        name="numberFBA"
                        onChange={(e) => {
                          onSaveCarsChanged(index + 3, e);
                        }}
                        type="text"
                        className={
                          state.cars[index + 2] && (state.cars[index + 2].receiving !== "" || state.cars[index + 2].quantity !== 0 || state.cars[index + 2].palletsNumber !== 0) && state.cars[index + 2].numberFBA === ""
                            ? "form-control error"
                            : "form-control"
                        }
                      />
                    </td>
                    <td>
                      <input
                        id={`quantity-of-units${index + 3}`}
                        name="quantity"
                        disabled={type === 'trailer' || type === 'bus, van'}
                        onChange={(e) => {
                          onSaveCarsChanged(index + 3, e);
                        }}
                        type="number"
                        className={
                          (type === 'trailer' || type === 'bus, van') // Jeśli jest zablokowane
                          ? "form-control" // Użyj domyślnej klasy
                          : (state.cars[index + 2] && (state.cars[index + 2].receiving !== "" || state.cars[index + 2].numberFBA !== "" || state.cars[index + 2].palletsNumber !== 0)) && (state.cars[index + 2].quantity === 0 || state.cars[index + 2].quantity === "")
                          ? "form-control error"
                          : "form-control"
                        }
                      />
                    </td>
                    <td>
                      <input
                        id={`no-of-pallets${index + 3}`}
                        name="palletsNumber"
                        disabled={type === 'loose'}
                        onChange={(e) => {
                          onSaveCarsChanged(index + 3, e);
                        }}
                        type="number"
                        className={
                          (type === 'loose') // Jeśli jest zablokowane
                          ? "form-control" // Użyj domyślnej klasy (bez błędu)
                          : (state.cars[index + 2] && (state.cars[index + 2].receiving !== "" || state.cars[index + 2].numberFBA !== "" || state.cars[index + 2].quantity !== 0)) && (state.cars[index + 2].palletsNumber === 0 || state.cars[index + 2].palletsNumber === "")
                          ? "form-control error"
                          : "form-control"
                        }
                      />
                    </td>
                  </tr>
                ))}
                <tr>
                  <td style={{ padding: "5px" }}></td>
                  <td style={{ padding: "5px" }}></td>
                  <td style={{ padding: "5px" }}></td>
                  <td
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    <FaPlus
                      style={{
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        color: "#ffc107",
                      }}
                      onClick={() => {
                        setFields(fields + 1);
                        dispatch(addCar());
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th scope="row">Total</th>
                  <td></td>
                  <td className="total-td">{unitsTotal}</td>
                  <td className="total-td">{palletsTotal}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
       <div className="mb-3">
  {firstDate ? ( // Uproszczone sprawdzenie, czy data istnieje
      <p>Delivery date: {moment(firstDate).format('DD.MM.YYYY HH:mm')}</p>
  ) : (
      ""
  )}
</div>
        <div className="mb-3">
          <button
            type="button"
            onClick={handleCheck}
            className="btn btn-warning"
          >
            Delivery Date
          </button>
          <Dialog open={open} onClose={handleOpen} as="div" className="relative z-50">
            <Transition show={open} as={Fragment}>
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition>
            <Transition
              show={open}
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: 9999 }}>
                <div className="flex items-center justify-center min-h-screen px-4">
                  <div
                    className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-96 overflow-auto"
                    style={{ width: "90vw", maxHeight: "80vh" }}
                  >
                    <Scheduler
                      date={firstDate}
                      handleOpen={handleOpen}
                      cars={state.cars}
                      reservationPools={reservationPools}
                      type={type}
                      customHolidays={customHolidays}
                      findAvailableDate={findAvailableDate}
                      checkNumberOfPallets={checkNumberOfPallets}
                    />
                  </div>
                </div>
              </div>
            </Transition>
          </Dialog>
          <ToastContainer style={{ width: "800px" }} autoClose={2000} />
        </div>
        <div className="mb-3">
          <label htmlFor="sealNumber" className="form-label">
            <div style={{ display: "flex", flexFlow: "row nowrap" }}>
              Seal number #1{" "}
              <div title="If there is no seal number, please enter 'without seal'" style={{ cursor: "pointer", marginLeft: "0.5rem" }}>
                <BiInfoCircle />
              </div>
            </div>
          </label>
          <input
            type="text"
            className="form-control"
            id="sealNumber"
            autoComplete="off"
            placeholder=""
            name="sealNumber"
            onChange={(e) => {
              hanleUpdate(e);
            }}
            required
          />
        </div>
        {state.type === "swapbody" ? (
          <div className="mb-3">
            <label htmlFor="sealNumber2" className="form-label">
              <div style={{ display: "flex", flexFlow: "row nowrap" }}>
                Seal number #2
                <div title="If there is no seal number, please enter 'without seal'" style={{ cursor: "pointer", marginLeft: "0.5rem" }}>
                  <BiInfoCircle />
                </div>
              </div>
            </label>
            <input
              type="text"
              className="form-control"
              id="sealNumber2"
              autoComplete="off"
              placeholder=""
              name="sealNumber2"
              onChange={(e) => {
                hanleUpdate(e);
              }}
            />
          </div>
        ) : (
          ""
        )}
        <div className="mb-3">
          <button
            type="button"
            onClick={sendPreAlert}
            className="btn btn-warning"
          >
            Send pre-alert
          </button>
        </div>
      </div>
      &nbsp;&nbsp;&nbsp;
      <div style={{ position: "relative", zIndex: 1 }}>
        <Footer />
      </div>
    </>
  );
}

export default PreAlert;
